export const formatDateWithSuffix = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();

  const getOrdinalSuffix = (n) => {
    if (n >= 11 && n <= 13) return `${n}th`;
    switch (n % 10) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  };

  const dayWithSuffix = getOrdinalSuffix(day);
  const monthShort = date.toLocaleString("default", { month: "short" });

  return `${monthShort} ${dayWithSuffix}`;
};

export const getRelativeTime = (input) => {
  if (!input) return "-";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "-";
  const now = new Date();
  const diff = (date.getTime() - now.getTime()) / 1000;

  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  const ranges = [
    { unit: "year", seconds: 31536000 },
    { unit: "month", seconds: 2592000 },
    { unit: "day", seconds: 86400 },
    { unit: "hour", seconds: 3600 },
    { unit: "minute", seconds: 60 },
    { unit: "second", seconds: 1 },
  ];

  for (let range of ranges) {
    if (Math.abs(diff) > range.seconds || range.unit === "second") {
      const delta = Math.round(diff / range.seconds);
      return rtf.format(delta, range.unit);
    }
  }
};

export const formatFullDateTime = (input) => {
  if (!input) return "-";
  const date = new Date(input);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${day} ${month} ${year} ${time}`;
};

export const formatDateWithoutYear = (input) => {
  if (!input) return "-";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "-";

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  return `${day} ${month}`;
};

export const formatDateTimeWithoutYear = (input) => {
  if (!input) return "-";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "-";

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${day} ${month} ${time}`;
};

/** e.g. "Apr 3, 3:45 PM" for session start labels */
export const formatSessionStart = (input) => {
  if (!input) return "-";
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return "-";
  const monthDay = date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
  });
  const time = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${monthDay}, ${time}`;
};

export const formatSessionDurationReadable = (startInput, endInput) => {
  if (!startInput || !endInput) return "-";
  const start = new Date(startInput).getTime();
  const end = new Date(endInput).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return "-";
  const mins = Math.round((end - start) / 60000);
  if (mins < 1) return "< 1 min";
  if (mins < 60) return mins === 1 ? "1 min" : `${mins} mins`;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  const hrPart = h === 1 ? "1 hr" : `${h} hrs`;
  if (m === 0) return hrPart;
  const minPart = m === 1 ? "1 min" : `${m} mins`;
  return `${hrPart} ${minPart}`;
};
